










































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VueDropDown } from '@/models/accounting/customerinfo';
import { FileViewModel, MessageCreateViewModel } from '@/models/telephony/message';
import {
  CustomerInfoViewModel,
  ExistingMessageViewModel,
  Attachment,
} from '@/models/accounting/customerinfo';
import { FileHelper } from '@/helper/file.helper';
import {
  ConversationTypes,
  MetadataType,
  MetadataKeyIdentifier,
  TemplateAssociationType,
} from '@/enums/enums';
import { Base } from '@/components/common/base';
import { messageService, templateService, customerService } from '@/shared';
import { IFileUploaderOption } from '@/models/fileUploader';
import { FileUploadDataViewModel } from '@/Alynk.dtos';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
    isValidate() {
      return this.messageToSend.to && this.messageToSend.body;
    },
  },
  components: {
    FileUpload: () => import('@/components/common/app.fileupload.v2.vue'),
  },
})
export default class SendMessage extends Base {
  public images = [
    '.ani',
    '.bmp',
    '.cal',
    '.fax',
    '.gif',
    '.img',
    '.jpg',
    '.jpe',
    '.jpeg',
    '.jpg',
    '.mac',
    '.pbm',
    '.pcd',
    '.pcx',
    '.pct',
    '.pgm',
    '.png',
    '.ppm',
    '.psd',
    '.ras',
    '.tga',
    '.tif',
    '.tiff',
    '.wmf',
    'image/ani',
    'image/bmp',
    'image/cal',
    'image/fax',
    'image/gif',
    'image/img',
    'image/jpeg',
    'image/mac',
    'image/pbm',
    'image/pcd',
    'image/pcx',
    'image/png',
    'image/tga',
    'image/tiff',
    'image/wmf',
    'image/ppm',
    'image/ppm',
    'image/psd',
    'image/ras',
  ];
  public allowedFiles = this.images.concat([
    '.pdf',
    '.doc',
    '.docx',
    '.txt',
    '.xls',
    '.xlsx',
  ]);

  public templateloading: boolean = false;
  public bodyloading: boolean = false;
  public customerloading: boolean = false;
  public selectedTemplate: string = '';
  public selectedCustomerNumber: string = '';
  public showAttachmentDialog: boolean = false;
  public files: any = [];
  public selectedFiles: any = [];
  public dragclass: string = '';
  public dragging: boolean = false;
  public disableSubmitButton: boolean = false;
  public fileRef: any;
  public templatedType: any;
  public fileUploderRef: string = "conversationMessageSendRef";
  public uploadBtnLoading: boolean = false;

  public syncAttachmentFiles(inputFilesToSync: any[], outputFilesToSync: FileUploadDataViewModel[]) {
    this.files = inputFilesToSync;
    this.messageToSend.files = outputFilesToSync;
  }

  public fileDialog: IFileUploaderOption = {
    ref: this.fileUploderRef,
    inputFiles: this.selectedFiles,
    multiple: true,
    drop: true,
    extensions: this.allowedFiles
  };

  public fileUploadLoader(val: boolean) {
    this.uploadBtnLoading = val;
  }

  public constants: any = {
    customerKey: '',
    recordKey: '',
    vin: '',
  };

  public attachments: Attachment[] = [];
  public customerNumberItems: VueDropDown[] = [];
  public templateItems: any[] = [];
  public customerInfo: any;
  public bodyRules: any = {
    required: (value) =>
      !!value ||
      (this.$parent.$t('sendMessage.validationBodyRequired') as string),
  };

  // tslint:disable-next-line:max-line-length
  public messageToSend: MessageCreateViewModel = new MessageCreateViewModel(
    ConversationTypes[ConversationTypes.Text]
  );

  constructor() {
    super();
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backTolist') {
      this.backToList();
    } else if (methodName === 'sendMessage') {
      if (!this.messageToSend.to || !this.messageToSend.body) {
        this.showAlert(false, this.$t('sendMessage.validationFormIsInvalid'));
        this.resetMethodName(methodName);
        return;
      }
      this.sendMessage();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$t('sendMessage.btnBackToList'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$t('sendMessage.btnBackToList'),
      click: 'backTolist',
      icon: 'fas fa-arrow-left',
    });
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    // activating tab
    if (this.$route.params.viewmode == 'admintextdashboard') {
      this.$root.$emit('sidebar.layout.vue', 'adminTextDashboard');
    } else if (this.$route.params.viewmode == 'mytextdashboard') {
      this.$root.$emit('sidebar.layout.vue', 'mytextdashboard');
    } else if (this.$route.query.tab == 'customerCharges') {
      this.$root.$emit('sidebar.layout.vue', 'customerCharges');
    } else if (this.$route.query.tab == 'deals') {
      this.$root.$emit('sidebar.layout.vue', 'deals');
    } else if (this.$route.query.tab == 'weowe') {
      this.$root.$emit('sidebar.layout.vue', 'weowe');
    }

    this.messageToSend.recordIdentifier = this.$route.params.type;

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    // SHOULD BIND CUSTOMER KEY, RECORD KEY
    Object.keys(this.constants).forEach((key) => {
      if (this.$route.query[key]) {
        this.constants[key] = (this.$route.query[key] || '').toString().trim();
      }
    });

    this.messageToSend.recordKey = this.constants.recordKey;
    this.messageToSend.vin = this.constants.vin;

    switch (this.messageToSend.recordIdentifier) {
      case MetadataType[MetadataType.Deal]:
        this.messageToSend.recordKeyIdentifier =
          MetadataKeyIdentifier[MetadataKeyIdentifier.DealNumber];
        this.templatedType = TemplateAssociationType.Deal;
        break;
      case MetadataType[MetadataType.Appointment]:
        this.messageToSend.recordKeyIdentifier =
          MetadataKeyIdentifier[MetadataKeyIdentifier.AppointmentNumber];
        this.templatedType = TemplateAssociationType.Appointment;

        break;
      case MetadataType[MetadataType.AR]:
        this.messageToSend.recordKeyIdentifier =
          MetadataKeyIdentifier[MetadataKeyIdentifier.CustomerNumber];
        this.templatedType = TemplateAssociationType.Customer;

        break;
      case MetadataType[MetadataType.RO]:
        this.messageToSend.recordKeyIdentifier =
          MetadataKeyIdentifier[MetadataKeyIdentifier.RepairOrderNumber];
        this.templatedType = TemplateAssociationType.Service;

        break;
      case MetadataType[MetadataType.WeOwe]:
        this.messageToSend.recordKeyIdentifier =
          MetadataKeyIdentifier[MetadataKeyIdentifier.WeOweNumber];
        this.templatedType = TemplateAssociationType.WeOwe;

        break;
      default:
        this.messageToSend.recordKeyIdentifier =
          MetadataKeyIdentifier[MetadataKeyIdentifier.Unknown];
        break;
    }

    this.getTemplates();
    if (this.constants.customerKey) {
      if (
        this.messageToSend.recordIdentifier ===
        MetadataType[MetadataType.Orphan]
      ) {
        this.messageToSend.recordKey = '';
      }
      this.getCustomerInfo();
    } else if (this.constants.recordKey) {
      if (
        this.messageToSend.recordIdentifier ===
        MetadataType[MetadataType.Orphan]
      ) {
        this.messageToSend.to = decodeURIComponent(this.constants.recordKey);
        this.messageToSend.recordKey = '';
        this.customerNumberItems = [
          { name: this.messageToSend.to, value: this.messageToSend.to },
        ];
      }
    }
  }

  public async getTemplates(): Promise<void> {
    try {
      this.templateloading = true;
      const templates = await templateService.getStoreTemplates(this.templatedType);
      this.templateItems = templates.results;
    } catch (e) {
      console.log(e);
    } finally {
      this.templateloading = false;
    }
  }

  public async getCustomerInfo(): Promise<void> {
    if (
      this.constants.customerKey == null ||
      this.constants.customerKey === ''
    ) {
      return;
    }
    try {
      this.customerloading = true;
      this.bodyloading = true;
      const customerInfo = await customerService.getCustomerInfoAsync(
        this.constants.customerKey
      );
      this.customerInfo = customerInfo;
      this.customerNumberItems = this.customerInfo.phoneNumberSelectList;

      this.messageToSend.customerName = this.customerInfo.customerName;
      this.messageToSend.customerKey = this.customerInfo.customerKey;

      const numbers = this.customerNumberItems
        .map((m) => m.value)
        .filter((v, i, a) => a.indexOf(v) === i);
      if (numbers.length === 1) {
        this.messageToSend.to = this.customerNumberItems[0].value;
      }
    } finally {
      this.customerloading = false;
      this.bodyloading = false;
    }
  }
  public async getTemplateDescription(selectedTemplateId): Promise<void> {
    this.bodyloading = true;
    if (selectedTemplateId == null || selectedTemplateId === '') {
      this.showAlert(false, this.$t('sendMessage.validationInvalidtemplate'));
      return;
    }
    try {
      const template = await templateService.getTemplateDescription(
        selectedTemplateId,
        this.messageToSend.customerName,
        this.messageToSend.vin,
        this.messageToSend.appointmentDateTime,
        this.messageToSend.appointmentNumber,
        '',
        '',
        this.messageToSend.customerKey,
        this.messageToSend.recordKey
      );
      this.messageToSend.body = template.text;
    } finally {
      this.bodyloading = false;
    }
  }

  public openAttachmentDialog(id: string): void {
    this.showAttachmentDialog = true;
  }

  public backToList() {
    if (history.state && history.length > 1) {
      this.$router.back();
    } else {
      this.$router.push({ name: 'app.weowe' });
    }
  }

  public async sendMessage(): Promise<void> {
    if (this.validateForm()) {
      if (
        this.messageToSend.to == null ||
        this.messageToSend.to === '' ||
        !this.messageToSend.body
      ) {
        // this.showAlert(
        //   false,
        //   this.$t('sendMessage.alertCustomerNumberFieldEmptyRequired')
        // );
        return;
      }
      try {
        this.disableSubmitButton = true;
        this.$emit('update:progress', this.disableSubmitButton);
        await messageService.sendMessage(this.messageToSend);
        this.messageToSend.body = '';
        this.showAlert(true, this.$t('sendMessage.messageSentSuccessfully'));
        this.messageToSend.files = [];
        this.selectedFiles = [];
        if (this.fileRef && this.fileRef.clear) {
          this.fileRef.clear();
        }
      } finally {
        this.disableSubmitButton = false;
        this.$emit('update:progress', this.disableSubmitButton);
        this.messageToSend.files = [];
        this.selectedFiles = [];
        this.$root.$emit('resetFileList', this.fileUploderRef);

      }
    }
  }


}
